/** Bulk guest tiers shown in the pricing table */
export const BULK_GUEST_TIERS = [50, 100, 150, 200, 300, 500];

export function getDiscount(guests) {
  const n = Number(guests) || 0;
  if (n >= 500) return 0.1;
  if (n >= 200) return 0.05;
  return 0;
}

/** Base subtotal before discount */
export function bulkSubtotal(perPlate, guests) {
  const p = Number(perPlate) || 0;
  const g = Math.max(0, Math.floor(Number(guests) || 0));
  return p * g;
}

export function totalForGuests(perPlate, guests) {
  const base = bulkSubtotal(perPlate, guests);
  return Math.round(base * (1 - getDiscount(guests)));
}

export function formatINR(n) {
  const x = Math.round(Number(n) || 0);
  return `₹${x.toLocaleString('en-IN')}`;
}
